import { render, staticRenderFns } from "./notification-name.vue?vue&type=template&id=387feb8e"
import script from "./notification-name.vue?vue&type=script&lang=js"
export * from "./notification-name.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/codebuild/output/src2585860866/src/clients/ap3/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('387feb8e')) {
      api.createRecord('387feb8e', component.options)
    } else {
      api.reload('387feb8e', component.options)
    }
    module.hot.accept("./notification-name.vue?vue&type=template&id=387feb8e", function () {
      api.rerender('387feb8e', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/notification-manager/components/notification-name.vue"
export default component.exports